import React from 'react';
import { Pressable, View } from 'react-native';
import { Link } from 'expo-router';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import { useInteractive } from '@/components/Landing/LandingKit';
import { AGENT_INTEGRATIONS, AGENT_INTEGRATION_MORE } from '@/constants/apiContent';
import { ApiBody, ApiEyebrow, ApiLink, ApiSection, ApiTitle, useApiDesign } from './ApiEditorial';

function IntegrationCard({ item }) {
  const { c, compact, mobile } = useApiDesign();
  const { hovered, handlers } = useInteractive();
  return (
    <Link href={item.href} asChild>
      <Pressable {...handlers} accessibilityRole="link" accessibilityLabel={`${item.name} setup guide`} style={{
        flexGrow: 1, flexBasis: mobile ? '100%' : compact ? '45%' : '21%', minWidth: 0,
        padding: 26, borderRadius: 20, borderWidth: 1, borderColor: hovered ? c.secondary : c.rule,
        backgroundColor: hovered ? c.soft : c.surface, gap: 22,
      }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <Text style={{ color: c.muted, fontSize: 12 }}>{item.kind === 'IDE' ? 'Code editor' : 'Coding agent'}</Text>
          <Icon name="arrow-up-right" size={13} color={c.secondary} />
        </View>
        <View style={{ gap: 6 }}>
          <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 22, lineHeight: 29, letterSpacing: -0.6 }}>{item.name}</Text>
          <Text style={{ color: c.secondary, fontSize: 12, lineHeight: 20 }}>{item.protocol}</Text>
        </View>
      </Pressable>
    </Link>
  );
}

function ApiAgents() {
  const { c } = useApiDesign();
  return (
    <ApiSection label="Coding agents and integrations">
      <ApiEyebrow>Fits your workflow</ApiEyebrow>
      <ApiTitle>Your tools. More possibilities.</ApiTitle>
      <ApiBody style={{ marginTop: 20, maxWidth: 650 }}>Keep the editor, agent, and SDK you love. Connect a Gab AI key for OpenAI and Anthropic request formats, streaming, and tool calls.</ApiBody>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 16, marginTop: 36 }}>
        {AGENT_INTEGRATIONS.map(item => <IntegrationCard key={item.name} item={item} />)}
      </View>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', columnGap: 26, rowGap: 4, marginTop: 24 }}>
        <Text style={{ color: c.muted, fontSize: 13 }}>Also works with</Text>
        {AGENT_INTEGRATION_MORE.map(item => <ApiLink key={item.name} href={item.href}>{item.name}</ApiLink>)}
      </View>
      <Text style={{ color: c.muted, fontSize: 12, lineHeight: 21, marginTop: 10 }}>Each guide includes base URLs, model settings, and client compatibility details.</Text>
    </ApiSection>
  );
}
export default React.memo(ApiAgents);
